import { api } from './index';

const DocumentService = {
  document_types() {
    return api.get('/document-types');
  },
  fiscal_years(area_id) {
    return api.get('/fiscal-years', { params: { __area_id: area_id } });
  },
  get(filters) {
    return api.get('/documents', { params: { ...filters } });
  },
  store(payload) {
    return api.post('/documents', payload);
  },
  delete(id) {
    return api.delete('/documents/'+id)
  },
  getContract() {
    return api.get('/documents/get-contract')
  }
};

export default DocumentService;